export default __webpack_public_path__ + "static/media/cert-customer-cpttm.dfee51bb.jpg";